// 检测是否为搜索引擎爬虫或自动化工具

export const isBot = () => {
  // 服务端渲染时返回 true（对爬虫隐藏）
  if (typeof window === 'undefined') {
    return true;
  }

  const userAgent = navigator.userAgent.toLowerCase();
  
  // 常见搜索引擎爬虫和自动化工具列表
  const botPatterns = [
    'googlebot',
    'bingbot',
    'slurp', // Yahoo
    'duckduckbot',
    'baiduspider',
    'yandexbot',
    'sogou',
    'exabot',
    'facebot', // Facebook
    'ia_archiver', // Alexa
    'adsbot-google',
    'apis-google',
    'mediapartners-google',
    'lighthouse',
    'chrome-lighthouse',
    'headlesschrome',
    'phantomjs',
    'selenium',
    'webdriver',
    'bot',
    'crawler',
    'spider',
    'scraper',
    'curl',
    'wget',
    'python-requests',
    'scrapy'
  ];

  // 检查是否匹配爬虫特征
  for (const pattern of botPatterns) {
    if (userAgent.includes(pattern)) {
      return true;
    }
  }

  // 检查是否有 webdriver 标记（自动化工具）
  if (navigator.webdriver) {
    return true;
  }

  // 检查是否有典型的爬虫特征
  if (!window.chrome && navigator.vendor === 'Google Inc.') {
    return true;
  }

  return false;
};

// 检测是否为真实用户（需要用户交互）
export const isRealUser = () => {
  return !isBot() && document.hasFocus();
};

